import { styled } from '@mui/material/styles';
import { svgIconClasses } from '@mui/material/SvgIcon';
import { CardBadgeProps } from './index';

export const StyledBadgeCard = styled('div', {
  shouldForwardProp: (prop: string) => !['hexColor'].includes(prop),
})<Partial<Pick<CardBadgeProps, 'hexColor'>>>((props) => {
  const { theme, hexColor } = props;

  const backgroundColor = hexColor
    ? `#${hexColor}`
    : theme.palette.customSuccess.mainCustom;

  return {
    display: 'inline-flex',
    justifyContent: 'center',
    position: 'relative',
    backgroundColor: backgroundColor,
    padding: `2px 24px`,
    gap: '4px',
    borderRadius: '8px 8px 0 0',
    color: theme.palette.neutral[0],
    ...theme.typography.smallText,
    fontWeight: 700,
  };
});

export const CardBadgeInvertedBorderRadius = styled('div')((props) => {
  const { theme } = props;
  const bgColor = theme.palette.customSuccess.mainCustom;

  return {
    backgroundImage: `radial-gradient(circle at 100% 100%, transparent 0%, transparent var(--payment-component-card-badge-border-radius), ${bgColor} var(--payment-component-card-badge-border-radius))`,
    position: 'absolute',
    width: 'var(--payment-component-card-badge-border-radius)',
    height: 'var(--payment-component-card-badge-border-radius)',
    bottom: 'calc(-1 * var(--payment-component-card-badge-border-radius))',
    left: 0,
  };
});

export const StyledIconWrapper = styled('span')(() => ({
  fontSize: '16px',
  lineHeight: '16px',

  [`& .${svgIconClasses.root}`]: {
    fontSize: '16px',
    lineHeight: '18px',
  },
}));
